// @ts-nocheck


import { EllipsisOutlined } from '@ant-design/icons';
import React, { Component, Fragment } from 'react';
import { Link } from '../../../lib/routerAdapter';
import { navigate } from '../../../lib/routerAdapter';
import { connect } from 'react-redux';
import styled from 'styled-components';
import Button from 'antd/lib/button';
import Menu from 'antd/lib/menu';

import { tireApi } from './../../../lib/api';
import { accessTypeEnum, seasonTypeTire } from '../../../lib/enum';

import {
  applyMaskToValue,
  getListInitialState,
  setQueryParams } from
'../../../lib/helpers';


import { Table, Dropdown } from './../../../components/ui';
import { Panel, Section } from './../../../components/layout';
import Filter from './Filter';
import Header from '../../../components/layout/Header';
import { Crumb } from '../../../components/layout/Breadcrumbs';
import Breadcrumbs from '../../../components/layout/Breadcrumbs';
import NavigationTabs from '../components/NavigationTabs';
import { withUserAccess } from './../../withUserAccess';
import CopyTireButton from './components/CopyTireButton';
import { formatLicensePlateMask } from '../../../components/inputs/masked-inputs/LicensePlateInput';

const StyledPanel = styled(Panel)`
  padding-bottom: 0;
  padding-top: 0;
`;
const PanelTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const canAddTireAccess = [
accessTypeEnum.admin,
accessTypeEnum.handlingEquipment];












/** Вывод списка шин */
class List extends Component {
  static defaultProps = {
    location: {}
  };

  getDefaultFilter = () => {
    const canViewAll = this.props.userAccess.some((access) =>
    [accessTypeEnum.viewingAllEquipments].includes(access)
    );
    const defaultFilter = canViewAll ?
    { ...null } :
    {
      orgUnitId: this.props.employeeBranchOrgUnitId,
      nodeFilterType: 'branchAndChildren'
    };
    return defaultFilter;
  };

  state = {
    ...getListInitialState(),
    filter: this.getDefaultFilter()
  };

  dropdown = {};

  fetchTires = async (
  page = 1,
  params = {}) =>
  {
    const { filter } = this.state;
    const { isArchive, ...otherFilters } = filter;
    this.setState({ loading: true });
    const { data, totalCount } = await tireApi.fetchTires({
      ...otherFilters,
      isArchive: isArchive === 'all' ? null : isArchive,
      page,
      ...params,
      ...this.getDefaultFilter() // фильтр по оргюнитам в зависимости от клэймов
    });
    setQueryParams({ page });
    this.setState({ loading: false, data, totalCount, page });
  };

  renderOverlay = (tire) =>
  <Menu>
      <Menu.Item>
        <CopyTireButton
        tire={tire}
        afterSubmit={() => {
          this.fetchTires(this.state.page);
          // $FlowFixMe тут id будет всегда
          if (this.dropdown[tire.id]) {
            this.dropdown[tire.id].onVisibleChange(false);
          }
        }} />

      </Menu.Item>
    </Menu>;


  getColumns = () => [
  { title: '№', dataIndex: 'id', sorter: true, width: 25 },
  {
    title: 'Марка',
    dataIndex: 'brand.name',
    sorter: true,
    sorterKey: 'brand.name'
  },
  {
    title: 'Наименование',
    dataIndex: 'name',
    sorter: true,
    render: (name, record) => {
      return `${name} ${record.width}/${record.profile} ${record.diameter}`;
    }
  },
  { title: 'Заводской номер', dataIndex: 'factoryNumber', sorter: true },
  {
    title: 'Тип шины',
    dataIndex: 'seasonType',
    sorter: true,
    render: (type) => seasonTypeTire[type] || '-'
  },
  {
    title: 'Гос. номер',
    dataIndex: 'vehicle',
    render: (vehicle) =>
    vehicle?.licensePlate ?
    <Link to={`/vehicles/${vehicle.id}`}>
            {applyMaskToValue(vehicle.licensePlate, formatLicensePlateMask)}
          </Link> :

    '-'

  },
  {
    title: 'Списано',
    dataIndex: 'isArchive',
    sorter: true,
    render: (isArchive) => isArchive ? 'Да' : 'Нет'
  },
  {
    title: '',
    width: '30px',
    // Нужно для того, чтобы не отрабатывал onRow
    onCell: () => ({ onClick: (e) => e.stopPropagation() }),
    render: (record) =>
    <Dropdown
    // $FlowFixMe тут id будет всегда
    ref={(dropdown) => this.dropdown[record.id] = dropdown}
    overlay={this.renderOverlay(record)}>

          <EllipsisOutlined style={{ fontSize: 16, color: '#2770FF' }} />
        </Dropdown>

  }];


  handleRowClick = (id) => navigate(`/equipment/tires/${id}`);

  cleanFilter = () => this.setState({ filter: { ...null } }, this.fetchTires);

  applyFilter = (filter) =>
  this.setState({ filter }, this.fetchTires);

  render() {
    const { location, userAccess } = this.props;

    const { data, totalCount, page, pageSize, loading, filter } = this.state;

    const canAdd = userAccess.some((access) => canAddTireAccess.includes(access));

    return (
      <Fragment>
        <Header
          left={
          <Breadcrumbs>
              <Crumb to="/">Главная</Crumb>
              <Crumb>Шины</Crumb>
            </Breadcrumbs>
          } />

        <StyledPanel>
          <PanelTitle>
            <h1>Шины</h1>
            {canAdd &&
            <Link to="/equipment/tires/new">
                <Button type="primary" data-cy="addTire">
                  Создать
                </Button>
              </Link>
            }
          </PanelTitle>
          <NavigationTabs defaultTab="tires" />
        </StyledPanel>
        <Section>
          <Filter
            filter={filter}
            applyFilter={this.applyFilter}
            cleanFilter={this.cleanFilter} />

          <Table
            data={data.map((tire) => ({
              ...tire,
              key: tire.id
            }))}
            loading={loading}
            onRow={(record) => ({
              onClick: () => this.handleRowClick(record.id)
            })}
            fetch={this.fetchTires}
            fetchOnMount
            columns={this.getColumns()}
            pagination={{
              page,
              pageSize,
              totalCount,
              location
            }} />

        </Section>
      </Fragment>);

  }
}

export default connect((state) => ({
  employeeBranchOrgUnitId: state.auth.profile.employeeBranchOrgUnitId
}))(withUserAccess(List));
